import { Vue } from "vue-property-decorator";
import { Question, QuestionType, Answer } from "@/interfaces";

export const mapAnswerFromQuestion = (questions: Question[]) =>
  questions.map(question => {
    let defaultAnswer: any = null;

    if (question.type === QuestionType.TEXT) {
      defaultAnswer = "";
    }

    if (question.type === QuestionType.TEXT_NUMBER) {
      defaultAnswer = 0;
    }

    if (
      question.type === QuestionType.CHECKBOX ||
      question.type === QuestionType.REPEATER ||
      question.type === QuestionType.CHECKBOX_WITH_MAP ||
      question.type === QuestionType.MULTI_SELECT
    ) {
      defaultAnswer = [];
    }

    if (question.type === QuestionType.GROUP) {
      defaultAnswer = {};

      if (question.items) {
        question.items.forEach(item => {
          if (item.type === QuestionType.CHECKBOX) {
            Vue.set(defaultAnswer, item.id, []);
          }
        });
      }
    }

    return {
      id: question.id,
      answer: defaultAnswer,
    };
  });

export const isEmpty = (obj: any) => {
  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      return false;
    }
  }
  return true;
};

export const validateQuestions = (questions: Question[], answers: Answer[]) => {
  return answers.every(answer => {
    const question = questions.find(q => q.id === answer.id);
    let validation = true;

    if (question && answer.answer !== null) {
      if (question.conf && !question.conf.readonly) {
        if (question.conf.max !== undefined) {
          if (typeof answer.answer === "number") {
            validation = validation && answer.answer <= question.conf.max;
          } else {
            validation = validation && answer.answer.length <= question.conf.max;
          }
        }

        if (question.conf.min !== undefined) {
          if (typeof answer.answer === "number") {
            validation = validation && answer.answer >= question.conf.min;
          } else if (answer.answer.length > 0) {
            validation = validation && answer.answer.length >= question.conf.min;
          }
        }

        if (question.conf.required) {
          if (Array.isArray(answer.answer)) {
            validation = validation && answer.answer.length > 0;
          } else if (typeof answer.answer === "object") {
            validation = validation && !isEmpty(answer.answer);
          } else {
            validation = validation && answer.answer !== "";
          }
        }
      }
    } else if (question) {
      if (question.conf && !question.conf.readonly) {
        if (question.conf.show_on) {
          const showOn = question.conf.show_on;
          const bindKey = "id";
          const valueKey = "value";
          const modelIndex = answers.findIndex(answer => answer.id === showOn[bindKey]);

          if (modelIndex !== -1) {
            const answer = answers[modelIndex].answer;
            validation = validation && answer !== showOn[valueKey];
          }
        } else if (question.conf.required) {
          validation = validation && answer.answer !== null;

          if (answer.answer !== null) {
            if (Array.isArray(answer.answer)) {
              validation = validation && answer.answer.length > 0;
            } else if (typeof answer.answer === "object") {
              validation = validation && !isEmpty(answer.answer);
            } else {
              validation = validation && answer.answer !== "";
            }
          }
        }
      }
    }

    return validation;
  });
};

export const validateQuestionsRequired = (questions: Question[], answers: Answer[]) => {
  return answers.every(answer => {
    const question = questions.find(q => q.id === answer.id);
    let validation = true;

    if (question && answer.answer !== null) {
      if (question.conf && !question.conf.readonly) {
        if (question.conf.required) {
          if (Array.isArray(answer.answer)) {
            validation = validation && answer.answer.length > 0;
          } else if (typeof answer.answer === "object") {
            validation = validation && !isEmpty(answer.answer);
          } else {
            validation = validation && answer.answer !== "";
          }
        }
      }
    } else if (question) {
      if (question.conf && !question.conf.readonly) {
        if (question.conf.show_on) {
          const showOn = question.conf.show_on;
          const bindKey = "id";
          const valueKey = "value";
          const modelIndex = answers.findIndex(answer => answer.id === showOn[bindKey]);

          if (modelIndex !== -1) {
            const answer = answers[modelIndex].answer;
            validation = validation && answer !== showOn[valueKey];
          }
        } else if (question.conf.required) {
          validation = validation && answer.answer !== null;

          if (answer.answer !== null) {
            if (Array.isArray(answer.answer)) {
              validation = validation && answer.answer.length > 0;
            } else if (typeof answer.answer === "object") {
              validation = validation && !isEmpty(answer.answer);
            } else {
              validation = validation && answer.answer !== "";
            }
          }
        }
      }
    }

    return validation;
  });
};

export const extractFromString = (text: string, beg: string, end: string): string[] => {
  const matcher = new RegExp(`${beg}(.*?)${end}`, "gm");
  const normalise = (str: string) => str.slice(beg.length, end.length * -1);

  const match = text.match(matcher);

  if (match !== null) {
    return match.map(normalise);
  }

  return [];
};

export const parseJwt = (token: string): Record<string, any> | null => {
  try {
    const payload = token.split(".")[1];
    const decoded = atob(payload);
    return JSON.parse(decoded);
  } catch (error) {
    console.error("Invalid JWT token:", error);
    return null;
  }
};
